import Icon from './Icon';
import type { IconName } from '@/theme/icons';

/** Ported from src/components/ui/IconChip.tsx — defaults to the tangerine soft chip. */
export default function IconChip({ icon, bg, fg, size = 40 }: {
  icon: IconName;
  bg?: string;
  fg?: string;
  size?: number;
}) {
  return (
    <span
      className="icon-chip"
      style={{ width: size, height: size, background: bg ?? 'var(--color-primary-soft)' }}
    >
      <Icon name={icon} size={Math.round(size * 0.5)} color={fg ?? 'var(--color-primary)'} />
    </span>
  );
}
